import { useMutation, useQuery } from 'react-query';
import * as notificationService from 'services/notificationService';

export const useGetNotifications = (page: number, pageSize: number, options = {}) => {
  return useQuery({
    queryKey: ['notifications', page, pageSize],
    queryFn: () => notificationService.getNotifications(page, pageSize),
    ...options,
  });
}

export const useMarkNotificationAsRead = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(notificationService.markNotificationAsRead, {
    onSuccess,
    onError,
    ...options,
  });
}

export const useGetUnreadNotificationsCount = (options = {}) => {
  return useQuery({
    queryKey: ['notificationsUnreadCount'],
    queryFn: notificationService.getUnreadNotificationsCount,
    ...options,
  });
}

export const useMarkNotificationsChecked = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(notificationService.markNotificationsChecked, {
    onSuccess,
    onError,
    ...options,
  });
}
